






import { defineComponent } from '@vue/composition-api';
import cQualPro            from '@/components/logo/qual-pro/qual-pro.component.vue';

export default defineComponent({
  name: 'cLoginHeader',
  components: {
    cQualPro,
  },
});
